import { useContext } from 'react';
import { createContext } from 'react';

import { ModalActionsProps } from '../@types/ModalActionsProps';

export const ModalActionsContext = createContext<ModalActionsProps>({} as ModalActionsProps);

ModalActionsContext.displayName = 'ModalActions';

const ModalActionsProvider = (props: ModalActionsProps) => (
	<ModalActionsContext.Provider value={props}>{props.children}</ModalActionsContext.Provider>
);

export const useModalActions = () => {
	const context = useContext(ModalActionsContext);

	return context;
};

export default ModalActionsProvider;
